import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { getMapContent, removeSlashes } from '../../../../utils/utils';
import { AccessibilityClickableDiv, AccessibilityHidden, AccessibilityHiddenImg } from '@skillz/accessibility';
import { deviceTypes } from '../../../../enums/deviceTypes';
import pathRouts from '../../../../enums/pathRoute';
import Text from '../../../shared/text/Text';
import classes from './TitlePages.module.css';
import Icon from '../../../ui/icons/Icon';
import iconsList from '../../../ui/icons/iconsList';
import GamesIcon from '../../../../assests/header/games.png';

const TitlePages = ({ pathname, showBackArrow, fromMenu }) => {

    const navigate = useNavigate();
    const { search } = useLocation();
    const { user, userDetails } = useSelector(state => state.auth);
    let currentRoute = Object.values(pathRouts).find((route) => route.route === removeSlashes(pathname));
    let pageTitle = currentRoute?.title || removeSlashes(pathname) || "Default";
    // to do shulamit its a quick fix (and bad code) to support right side handle games island in map
    if (fromMenu && pageTitle === pathRouts.CURATORSHIP.route && search?.includes && search.toLocaleLowerCase().includes('games')) {
        let mapContent = getMapContent(user, userDetails);
        let mapContentValues = Object.values(mapContent)
        if (mapContentValues.find(i => i.text === "games")) {
            currentRoute = { img: GamesIcon }
            pageTitle = "games";
        }
    }
    const { texts } = useSelector(state => state.translate);
    const { deviceType } = useSelector(state => state.responsive);

    return (
        <div className={classes.TitlePages}>
            {showBackArrow &&
                <AccessibilityClickableDiv className={classes.Back} onClick={() => navigate(pathRouts.HOME.route)} accessibilityDescription={texts.back}>
                    <Icon size="100%" name={iconsList.back} />
                </AccessibilityClickableDiv>}

            {pathname && <div className={classes.Name}>
                {currentRoute?.img && <AccessibilityHiddenImg
                    className={classes.Img}
                    src={currentRoute.img}
                />}
                <Text elementType={deviceType !== deviceTypes.desktop ? 'h1' : 'p'} className={classes.Text}>{texts[pageTitle]}</Text>
            </div>}
        </div>
    )
}

export default TitlePages;